module.exports = __webpack_public_path__ + "img/services-one-2.3b97e0af.png";